import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
import { useNavigate } from "react-router-dom";
import { ta } from "date-fns/locale";

export default function ProjectExpertStatus({
  status,
  expert_id,
  project_id,
  setPartiallyAvailable,
  setNewStatus,
  backupData,
  setBackupData,
  setIsVerified,
  tableData,
  setTableData,
}) {
  const { API_URL } = useContext(UrlContext);
  const [expertStatus, setExpertStatus] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [profileStatusStyle, setProfileStatusStyle] = useState({
    background: "white",
    color: "black",
  });
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (status) {
      setExpertStatus(status);
    }
    if (status === "Partially Available") {
      setPartiallyAvailable(true);
    } else {
      setPartiallyAvailable(false);
    }
  }, [status]);

  useEffect(() => {
    if (expertStatus === "0") {
      setProfileStatusStyle({ background: "white", color: "black" });
    } else if (expertStatus === "Responded") {
      setProfileStatusStyle({ background: "#9FE2BF", color: "black" });
    } else if (expertStatus === "Interested") {
      setProfileStatusStyle({ background: "greenyellow", color: "black" });
    } else if (expertStatus === "Partially Available") {
      setProfileStatusStyle({ background: "#ffc000", color: "black" });
    } else if (expertStatus === "Not Interested") {
      setProfileStatusStyle({ background: "#ff3333", color: "white" });
    } else if (expertStatus === "Participated") {
      setProfileStatusStyle({ background: "green", color: "white" });
    } else if (expertStatus === "Contracting") {
      setProfileStatusStyle({ background: "rgb(255, 192, 0)", color: "black" });
    }
  }, [expertStatus]);

  useEffect(() => {
    const fetchParticipatedCount = async () => {
      setLoading(true);
      setReturnError(false);
      const url = `${API_URL}fetch-participated-count`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ projectID: project_id, expertID: expert_id }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setLoading(false);
            if (data.participatedCount > 0) {
              setCount(data.participatedCount + 1);
            }
            // setNDAStatus(data.currentNDAStatus);
          } else {
            setLoading(false);
            setReturnError(true);
            console.log("Error fetching pariticipated count!");
            // setError(true);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          setReturnError(true);
        });
      // setLoading(false);
    };
    if(expertStatus==="Participated"){
      fetchParticipatedCount();
    }
  }, [expertStatus]);

  const handleStatusChange = (value) => {
    if (value === "Participated") {
      navigate(`/app/ProjectInformation/${project_id}/${expert_id}/0`);
      return;
    }
    if (value === "Contracting") {
      navigate(`/app/ProjectInformation/${project_id}/${expert_id}/1`);
      return;
    }

    setReturnError(false);
    setLoading(true);

    setExpertStatus(value);
    setNewStatus(value);
    if (value === "Partially Available") {
      setPartiallyAvailable(true);
    } else {
      setPartiallyAvailable(false);
    }
    const url = `${API_URL}update-project-expert-status`;
    const data = {
      status: value,
      expertID: expert_id,
      projectID: project_id,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          const updatedBackupData = backupData.map((item) => {
            if (item.expert.ID === expert_id) {
              item.expertStatus = value;
              if ((value === "Interested" || value === "Participated") && item.expert.email !== 'email@email.com') {
                setIsVerified(true);
              }
            }
            return item;
          });
          setBackupData([...updatedBackupData]);
          setTableData([...updatedBackupData]);
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
    
  };

  const loadingOffset = 
    count && expertStatus === 'Participated'
      ? "ml-[60px]" : expertStatus === 'Participated'
      ? "ml-[30px]" : "ml-[-17px]";

  return (
    <>
      <div className="relative flex flex-row items-center justify-center gap-2">
        {/* Regular status section */}
        <select
          style={profileStatusStyle}
          onChange={(e) => {handleStatusChange(e.target.value)}}
          value={expertStatus}
        >
          <option value="0">No Information</option>
          <option value="Responded">Responded</option>
          <option value="Interested">Interested</option>
          <option value="Partially Available">Partially Available</option>
          <option value="Not Interested">Not Interested</option>
          <option value="Contracting">Contracting</option>
          <option value="Participated">Participated</option>
        </select>
        <div className="absolute left-full ml-2">
          <div className="relative flex flex-row items-center justify-center gap-2">
            {/* Count for total participation */}
            { loading ? (
              <div className="relative w-4"><i class="fa-solid fa-spinner fa-spin absolute -top-3 text-[#365561]"></i></div>
            ) : (
              <>
              {count > 0 && (
                <div className="group relative flex flex-col items-center">
                  <div
                    style={{
                      width: "25px",
                      height: "25px",
                      borderRadius: "50%",
                      marginBottom: "6px",
                      background: "rgb(62, 84, 96)",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "15px",
                      fontWeight: "bold",
                      cursor: "default",
                    }}
                  >
                    {count}
                  </div>
                  <p className="absolute bottom-full rounded-[5px] mb-2 bg-[#365561] pl-2 pt-1 pr-2 pb-1 text-sm text-white w-[170px] opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                    No. of total participation
                  </p>
                </div>
              )}
              </>
            )}
            
            {/* Extension button */}
            {expertStatus === "Participated" && (
              <div className="group relative flex flex-col items-center">
                <i 
                  className="fa-solid fa-circle-plus cursor-pointer mb-2 text-gray-400 hover:text-gray-600 transition-colors duration-300"
                  aria-hidden="true" 
                  onClick={() =>
                    navigate(`/app/ProjectInformation/${project_id}/${expert_id}/0/1`)
                  }
                />
                {/* Tooltip */}
                <p className="absolute bottom-full rounded-[5px] mb-[12px] bg-[#365561] pl-2 pt-1 pr-2 pb-1 text-sm text-white w-[110px] opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                  Click to extend
                </p>
              </div>
            )}
          </div>
        </div>
        
        {returnSuccess && (
          <img
            className={`absolute return-msg-icon left-full top-[6px] ${loadingOffset}`}
            src={successIcon}
            alt="success"
            title="Success"
          />
        )}
        {returnError && (
          <img
            className={`absolute return-msg-icon left-full top-[6px] ${loadingOffset}`}
            src={errorIcon}
            alt="error"
            title="Error! Please reload"
          />
        )}
      </div>
    </>
  );
}
